// extracted by extract-css-chunks-webpack-plugin
module.exports = {"no-appearance-button":"_3AJC6j"};